import React from 'react'
import { GlobalPadding } from './Wrappers'
import { breakpoint } from '@configs/utilities'
import styled from 'styled-components'
import wavesTop from '@assets/images/config/wavesTop.svg'
import wavesBottom from '@assets/images/config/wavesBottom.svg'

const SectionWrapper = ({
  children,
  sectionBackground,
  showBackground = false,
  backgroundImage,
  backgroundSize,
  showWaves = false,
  wavesPosition = 'bottom',
  hidePaddingBottom = false,
}) => {
  if (showWaves) {
    return (
      <WrapperWaves
        sectionBackground={sectionBackground}
        wavesPosition={wavesPosition}
        hidePaddingBottom={hidePaddingBottom}
      >
        <GlobalPadding>{children}</GlobalPadding>
      </WrapperWaves>
    )
  }

  if (showBackground) {
    return (
      <WrapperBackground
        sectionBackground={sectionBackground}
        hidePaddingBottom={hidePaddingBottom}
        backgroundImage={backgroundImage}
        backgroundSize={backgroundSize}
      >
        <GlobalPadding>{children}</GlobalPadding>
      </WrapperBackground>
    )
  }

  return (
    <Wrapper sectionBackground={sectionBackground} hidePaddingBottom={hidePaddingBottom}>
      <GlobalPadding>{children}</GlobalPadding>
    </Wrapper>
  )
}

export default SectionWrapper

const Wrapper = styled.div`
  background: ${(props) => props.sectionBackground};
  padding: 30px 0 ${(props) => (props.hidePaddingBottom ? 0 : '30px')};

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 40px 0 ${(props) => (props.hidePaddingBottom ? 0 : '40px')};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 60px 0 ${(props) => (props.hidePaddingBottom ? 0 : '50px')};
  }
`

const WrapperWaves = styled.div`
  background: ${(props) => props.sectionBackground};
  background-image: ${(props) => (props.wavesPosition === 'bottom' ? `url(${wavesBottom})` : `url(${wavesTop})`)};
  background-repeat: no-repeat;
  background-position: ${(props) => props.wavesPosition};
  background-size: ${(props) => (props.backgroundSize ? props.backgroundSize : 'contain')};
  padding: 30px 0 ${(props) => (props.hidePaddingBottom ? 0 : '30px')};

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 40px 0 ${(props) => (props.hidePaddingBottom ? 0 : '40px')};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 60px 0 ${(props) => (props.hidePaddingBottom ? 0 : '50px')};
  }
`

const WrapperBackground = styled.div`
  background: ${(props) => props.sectionBackground};

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: ${(props) => (props.backgroundSize ? props.backgroundSize : 'contain')};
  padding: 30px 0 ${(props) => (props.hidePaddingBottom ? 0 : '30px')};

  @media screen and (min-width: ${breakpoint.md}) {
    background-image: ${(props) => `url(${props.backgroundImage})`};
    padding: 40px 0 ${(props) => (props.hidePaddingBottom ? 0 : '40px')};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 60px 0 ${(props) => (props.hidePaddingBottom ? 0 : '50px')};
  }
`
